import React from 'react';
import styled from 'styled-components';
import { useDroppable } from '@dnd-kit/core';
import type { LeadStage } from '../../../../Data/leads.dto';

interface DroppableColProps {
  stage: LeadStage;
  children: React.ReactNode;
  isValidTarget: boolean;
  isDragActive: boolean;
}

const Column = styled.div<{ isOver?: boolean; isInvalid?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  background: ${(p) =>
    p.isOver
      ? 'linear-gradient(180deg, rgba(255, 201, 81, 0.12) 0%, rgba(206, 86, 176, 0.08) 100%)'
      : '#fff'};
  border-radius: 18px;
  padding: 14px 14px 12px;
  position: relative;
  transition: background 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  border: 1px solid ${(p) => (p.isOver ? 'rgba(201, 77, 170, 0.28)' : 'rgba(0, 0, 0, 0.06)')};
  box-shadow: ${(p) =>
    p.isOver
      ? '0 10px 28px rgba(201, 77, 170, 0.12)'
      : '0 6px 20px rgba(0, 0, 0, 0.04)'};

  ${(p) =>
    p.isInvalid &&
    `
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 18px;
      background: rgba(156, 163, 175, 0.14);
      pointer-events: none;
    }
  `}
`;

const DroppableColumn: React.FC<DroppableColProps> = ({
  stage,
  children,
  isValidTarget,
  isDragActive,
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id: stage,
    disabled: !isValidTarget && isDragActive,
  });

  return (
    <Column
      ref={setNodeRef}
      isOver={isOver && isValidTarget}
      isInvalid={isDragActive && !isValidTarget}
    >
      {children}
    </Column>
  );
};

export default DroppableColumn;
